type MarketLoadingIndicatorProps = {
  message: string
  /** Compact inline variant for overlays. */
  compact?: boolean
}

export const MarketLoadingIndicator = ({ message, compact = false }: MarketLoadingIndicatorProps) => (
  <div
    className={compact ? 'market-loading market-loading--compact' : 'market-loading'}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="market-spinner" aria-hidden="true" />
    <span className="market-loading__message">{message}</span>
  </div>
)
